// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reset-password-container .title{font-size:22px;margin-bottom:20px}.reset-password-container .invalid-feedback{color:#fff}", ""]);
// Exports
module.exports = exports;
